import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

interface SettingCardProps {
  title: string;
  menuItems: any;
  imgIcon: any;
  handleClick: (value: any) => void;
}

export default function SettingCard({
  title = "Your title",
  menuItems = [{ label: "Your Title", value: "yourTitle" }],
  imgIcon,
  handleClick,
}: SettingCardProps) {
  const [checked, setChecked] = React.useState([1]);

  const handleToggle = (value: number) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  return (
    <div
      className="w-[100%] rounded-[8px]"
      style={{ border: "1px solid #E9E9E9" }}
    >
      <div className="flex items-start gap-3 pt-3 pl-3">
        <img src={imgIcon} alt="setting-item-icon" />
        <div className="text-base font-medium text-[#005596]">{title}</div>
      </div>
      <List sx={{ width: "100%", bgcolor: "background.paper" }}>
        {menuItems?.map((data: any) => {
          const labelId = `checkbox-list-secondary-label-${data?.value}`;
          return (
            <ListItem
              onClick={() => {
                handleClick(data?.value);
              }}
              key={data?.value}
              secondaryAction={
                <KeyboardArrowRightIcon className="text-[#393939]" />
              }
              disablePadding
            >
              <ListItemButton style={{ padding: "10px 16px" }}>
                <div className="text-base font-normal text-[#565656]">
                  {data?.label}
                </div>
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
}
